module.exports = __webpack_public_path__ + "static/media/Asset 7.08012840.svg";